import React, { useContext, useState } from 'react'
import Skeleton from '../../components/ui/Skeleton';
import { formatNumber, getPriceHelper, minutesToHour } from '../../utils/Helper';
import authContext from '../../context/authContext';
import { USER_ROLE_TYPES } from '../../constants/Constants';
import Button from '../../components/ui/Button';
import Checkbox from '../../components/layouts/CheckBox';
import FinalizeContributionInfoModal from './FinalizeContributionInfoModal';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import toast from 'react-hot-toast';
import ProfileImage from '../../components/layouts/ProfileImage';
import { Tooltip as ReactTooltip } from "react-tooltip";

interface dataTypes {
    rows?: object[],
    total_chores_hours: string | number,
    total_chores_price: string | number,
    total_expenses_price: string | number,
    total_hours_of_employment: string | number,
    total_hours_of_labour: string | number,
    total_unpaid_expenses: string | number,
}

const ContributionsDetails = ({ data, currentForm, loading, isFinalized, onFinalize, onPressSubmit, fromReport = false }: {
    data?: dataTypes,
    currentForm?: { start_date: string, end_date: string },
    loading: boolean,
    isFinalized?: boolean,
    onFinalize?: (val: boolean) => void
    onPressSubmit?: (split: any, finalizeValue?: boolean) => void
    fromReport?: boolean
}) => {

    let profile: any = useContext(authContext);
    const sendReminderContribution = useMakeRequest();

    const [final, setFinal] = useState(false)
    const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
        totalHours: false,
        totalExpenses: false,
        totalPaid: false,
        totalUnpaid: false,
        currentBalances: false,
        finalizedBalances: false
    });

    const onPressSend = () => {
        toast.promise(
            sendReminderContribution.makeRequest({
                url: ApiConstants.sendReminder,
                payload: {
                    hh_id: profile?.data?.hh_member?.household?.id,
                    start_date: currentForm?.start_date,
                    end_date: currentForm?.end_date,
                    reminder_type: 1
                },
            }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }

    const toggleSection = (section: string) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    }

    return (
        <div className='pt-3'>
            {
                loading ?
                    Array.from({ length: 3 })?.map(() => (
                        <div className='dark-bg page-padding-x pt-3'>
                            <div className='contro-member-card'>
                                <div className='member-card-head'>
                                    <Skeleton className='skeleton-loader household-u-img' style={{ width: '32px', height: '32px', borderRadius: '50px' }} />
                                    <span><Skeleton className='skeleton-loader ms-2' style={{ width: '100px', height: '20px', borderRadius: '2px' }} /></span>
                                </div>
                                <div className='member-card-body'>
                                    <div className='row gy-3'>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-loader m-card-label' style={{ width: '100px', height: '20px', borderRadius: '2px' }} />
                                            <Skeleton className='skeleton-loader label-ct' style={{ width: '80px', height: '20px', borderRadius: '2px' }} />
                                        </div>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-loader m-card-label' style={{ width: '100px', height: '20px', borderRadius: '2px' }} />
                                            <Skeleton className='skeleton-loader label-ct' style={{ width: '120px', height: '20px', borderRadius: '2px' }} />
                                        </div>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-loader m-card-label' style={{ width: '100px', height: '20px', borderRadius: '2px' }} />
                                            <Skeleton className='skeleton-loader label-ct' style={{ width: '80px', height: '20px', borderRadius: '2px' }} />
                                        </div>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-loader m-card-label' style={{ width: '100px', height: '20px', borderRadius: '2px' }} />
                                            <Skeleton className='skeleton-loader label-ct' style={{ width: '120px', height: '20px', borderRadius: '2px' }} />
                                        </div>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-loader m-card-label' style={{ width: '100px', height: '20px', borderRadius: '2px' }} />
                                            <Skeleton className='skeleton-loader label-ct' style={{ width: '80px', height: '20px', borderRadius: '2px' }} />
                                        </div>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-loader m-card-label' style={{ width: '100px', height: '20px', borderRadius: '2px' }} />
                                            <Skeleton className='skeleton-loader label-ct' style={{ width: '120px', height: '20px', borderRadius: '2px' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className='member-card-foot'>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-loader member-balance-label' style={{ width: '100px', height: '20px', borderRadius: '10px' }} />
                                        </div>
                                        <div className='col-6'>
                                            <Skeleton className='skeleton-member-balance' style={{ width: '50px', height: '20px', borderRadius: '20px' }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    data?.rows && data?.rows?.length > 0 ?
                        <>
                            {data?.rows?.map((contro: any, index: number) => {
                                const userImg = contro?.member_details?.profile_pic;
                                const userName = contro?.member_details?.name;
                                const monthlyWorkHour = contro?.member_details?.monthly_work_hour || 0;
                                const totalChoresHours = Number(minutesToHour(contro?.total_chores_hours)) || 0;
                                const totalChoresPrice = contro?.total_chores_price;
                                const totalExpensesPrice = contro?.total_expenses_price;
                                const totalPaidExpensesPrice = contro?.total_expenses_paid;
                                const totalBalance = contro?.total_balance;
                                const expectedContribution = contro?.expected_contribution;
                                const balanceStatus = Number(totalBalance) > 0 ? contro?.balance_status === 'positive' ? '-' : '+' : '';

                                return (
                                    <div className='page-padding-x mt-3' key={index}>
                                        <div className={`contro-member-card ${index % 2 === 0 ? 'yellow-card' : 'green-card'}`}>
                                            <div className='member-card-head'>
                                                <div className='head-left'>
                                                    <ProfileImage src={userImg} size={30} />
                                                    <span className='ms-2'>{userName}</span>
                                                </div>
                                                <div className='head-right'>
                                                    <span className='balance-amount'>{`${balanceStatus}${getPriceHelper(totalBalance)}`}</span>
                                                    {index == 0 &&
                                                        <>
                                                            <abbr
                                                                data-tooltip-id={userName}
                                                                className="text-decoration-none cursor-pointer"
                                                            >
                                                                {""}
                                                                <i className="icon-info ms-2"></i>
                                                            </abbr>
                                                            <ReactTooltip
                                                                style={{
                                                                    zIndex: "1",
                                                                    wordBreak: "break-word",
                                                                    maxWidth: "90%",
                                                                }}
                                                                id={userName}
                                                                place="bottom"
                                                                content={"All balances are rounded to two decimal points. In order to avoid rounding errors, the admin's balance may be  adjusted slightly."}
                                                            />
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                            <div className='member-card-body'>
                                                <div className='body-row'>
                                                    <span className='body-label'>Expected Contribution</span>
                                                    <span className='body-value'>{getPriceHelper(expectedContribution)}</span>
                                                </div>
                                                <div className='body-row'>
                                                    <span className='body-label'>Value of Chores</span>
                                                    <span className='body-value'>{getPriceHelper(totalChoresPrice)}</span>
                                                </div>
                                                <div className='body-row'>
                                                    <span className='body-label'>Expenses Paid</span>
                                                    <span className='body-value'>{getPriceHelper(totalPaidExpensesPrice)}</span>
                                                </div>
                                                <div className='body-row hours-row'>
                                                    <span className='body-label'>Chores</span>
                                                    <span className='body-value'>{totalChoresHours} hrs</span>
                                                </div>
                                                <div className='body-row hours-row'>
                                                    <span className='body-label'>Employment</span>
                                                    <span className='body-value'>{monthlyWorkHour} hrs</span>
                                                </div>
                                                <div className='body-row hours-row'>
                                                    <span className='body-label'>Labor</span>
                                                    <span className='body-value'>{totalChoresHours + monthlyWorkHour} hrs</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            {!fromReport && profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN && <div className='divider' />}
                            <div className='page-padding-x'>
                                {!fromReport && profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN &&
                                    <>
                                        <div className='com-input-grp'>
                                            <label className="form-label-larg mb-4">
                                                Finalize Contributions
                                            </label>
                                            <label className="form-label-small">
                                                Notify members that contributions will be finalized soon.
                                            </label>
                                        </div>
                                        <Button
                                            className="com-btn-arraow mb-2 mt-2"
                                            onClick={onPressSend}
                                        >
                                            Send reminder
                                        </Button>
                                    </>
                                }
                                {!fromReport && profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN && (
                                    <div className="form-check com-check check-green mb-4">
                                        {/* <Checkbox
                                            id="finalizeCheck"
                                            disabled={loading}
                                            onChange={(e) => {
                                                const modal: any = $("#FinalizeContributionInfo");
                                                modal.modal("show");
                                                onFinalize && onFinalize(isFinalized ? false : true)
                                                setFinal(e?.target?.checked)
                                            }}
                                            checked={final}
                                            labelText={`${!isFinalized ? "Finalize" : "Unfinalize"} contributions`}
                                            customLabelClassName='finalize-check-box-label'
                                        /> */}

                                        <Checkbox
                                            id="finalizeCheck"
                                            disabled={loading}
                                            onChange={(e) => {
                                                const checked = e?.target?.checked;
                                                // If currently finalized → this means UNFINALIZE
                                                if (isFinalized) {
                                                    // Directly perform what onConfirm does
                                                    onPressSubmit && onPressSubmit(null, false);
                                                    onFinalize && onFinalize(false);
                                                    setFinal(false);
                                                    return;
                                                }

                                                // Otherwise → FINALIZE (open modal)
                                                const modal: any = $("#FinalizeContributionInfo");
                                                modal.modal("show");
                                                onFinalize && onFinalize(true);
                                                setFinal(checked);
                                            }}
                                            checked={final}
                                            labelText={`${!isFinalized ? "Finalize" : "Unfinalize"} contributions`}
                                            customLabelClassName='finalize-check-box-label'
                                        />

                                    </div>
                                )}
                            </div>

                            {!fromReport && <div className='divider' />}

                            <div className='summary-section'>
                                <h3 className='summary-title'>Summary</h3>

                                {/* Total Value of Chores */}
                                <div className='summary-item'>
                                    <div className='summary-item-header'>
                                        <span className='summary-item-label'>Total Value of Chores</span>
                                        <span className='summary-item-value'>{getPriceHelper(data?.total_chores_price) || 0}</span>
                                    </div>
                                </div>

                                {/* Total Expenses */}
                                <div className='summary-item'>
                                    <div className='summary-item-header'>
                                        <span className='summary-item-label'>Total Expenses</span>
                                        <span className='summary-item-value'>{getPriceHelper(data?.total_expenses_price) || 0}</span>
                                    </div>
                                </div>

                                {/* Total Unpaid Expenses */}
                                <div className='summary-item'>
                                    <div className='summary-item-header'>
                                        <span className='summary-item-label'>Total Unpaid Expenses</span>
                                        <span className='summary-item-value'>{getPriceHelper(data?.total_unpaid_expenses) || 0}</span>
                                    </div>
                                </div>

                                {/* Total Hours of Chores */}
                                <div className='summary-item'>
                                    <div className='summary-item-header'>
                                        <span className='summary-item-label'>Total Hours of Chores</span>
                                        <span className='summary-item-value'>{data?.total_chores_hours || 0}</span>
                                    </div>
                                </div>

                                {/* Total Hours of Employment */}
                                <div className='summary-item'>
                                    <div className='summary-item-header'>
                                        <span className='summary-item-label'>Total Hours of Employment</span>
                                        <span className='summary-item-value'>{formatNumber(data?.total_hours_of_employment) || 0}</span>
                                    </div>
                                </div>

                                {/* Total Hours of Labor */}
                                <div className='summary-item'>
                                    <div className='summary-item-header'>
                                        <span className='summary-item-label'>Total Hours of Labor</span>
                                        <span className='summary-item-value'>{formatNumber(data?.total_hours_of_labour) || 0}</span>
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex info-box'>
                                <abbr
                                    data-tooltip-id={"balance-info"}
                                    className="text-decoration-none cursor-pointer"
                                >
                                    {" "}
                                    <i className="icon-info ms-2"></i>
                                </abbr>
                                <label className="info-text">
                                    All balances are based on information entered or provided by users. Justivide does not guarantee the accuracy of the amounts listed above.
                                </label>
                            </div>
                        </>
                        : ""}

            <FinalizeContributionInfoModal
                title=''
                toggleModal={() => {
                    const modal: any = $("#FinalizeContributionInfo");
                    modal.modal("hide");
                    setFinal(isFinalized || false)
                }}

                onConfirm={() => {
                    onPressSubmit && onPressSubmit(null, true);
                    setFinal(false)
                    const modal: any = $("#FinalizeContributionInfo");
                    modal.modal("hide");
                }}

                title2='After the contributions are finalized, users will not be able to add or edit chores, expenses, or contributions for this budget period.'
            />
        </div>
    )
}

export default ContributionsDetails